import * as React from 'react'

function ProfileCircleIcon(props: any) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20.001} viewBox="0 0 20 20.001" {...props}>
      <g data-name="Group 52577">
        <g
          data-name="Group 9107"
          transform="translate(-24 -183) translate(27 184.5)"
          fill="none"
          stroke="CurrentColor"
          strokeLinejoin="round"
          strokeWidth={1.5}
        >
          <path data-name="Path 13391" d="M10.549 11.841a3.736 3.736 0 00-3.486-1.793 4.061 4.061 0 00-3.612 1.793" />
          <rect data-name="Rectangle 3283" width={4.887} height={4.887} rx={2.443} transform="translate(4.556 5.16)" />
          <g data-name="Rectangle 3661" transform="translate(-3 -1.5)">
            <rect width={20} height={20.001} rx={10} stroke="none" />
            <rect x={0.75} y={0.75} width={18.5} height={18.501} rx={9.25} />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default ProfileCircleIcon
